export const mMaxFileSizeMB = 20;
export const mMaxFileSize = mMaxFileSizeMB * 1024 * 1024;
export const mMaxFiles = 10;

export const mImageFormats = ["image/png", "image/jpeg", "image/webp", "image/avif", "image/svg+xml"];
export const mImageExtensions = ["PNG", "JPG", "WEBP", "AVIF", "SVG"];
export const mVideoFormats = ["video/mp4", "video/webm"];
export const mVideoExtensions = ["MP4", "WEBM"];
export const mChatAttachmentFormats = [...mImageFormats, ...mVideoFormats];

export const mDropzoneImageAccept = {
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/avif": [".avif"],
  "image/svg+xml": [".svg"],
  "image/jpeg": [".jpg", ".jpeg"],
};

export const mDropzoneVideoAccept = {
  "video/mp4": [".mp4"],
  "video/webm": [".webm"],
};

export const mLibraryDropzoneAccept = {
  ...mDropzoneImageAccept,
  ...mDropzoneVideoAccept,
};

export const mBrandGuidelinesFileFormats = ["application/pdf", "text/markdown", "text/x-markdown", "text/plain", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
export const mBrandGuidelinesFileExtensions = ["pdf", "md", "markdown", "txt", "docx"];
export const mAllowedHosts = ["assets.zocket.com"];

export const mExtensionTypeMap: Record<string, string> = {
  image: "png",
  video: "mp4",
};
